export const defaultOption = {
    default: 'left',
    target: ['paragraph', 'heading'],
    options: [
        {
            label: '左对齐',
            value: 'left',
        },
        {
            label: '居中对齐',
            value: 'center',
        },
        {
            label: '右对齐',
            value: 'right',
        },
        {
            label: '两端对齐',
            value: 'justify',
        },
    ],
};
//# sourceMappingURL=data.js.map